import React, { useLayoutEffect } from "react";
import { useTracked } from "./state";
import { MQ } from "./services/mq";

interface Props {
  config: any;
}

const AppConfig: React.FC<Props> = ({ config }) => {
  const [, dispatch] = useTracked();

  useLayoutEffect(() => {
    if (config) {
      initAppConfig(config);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config]);

  const initAppConfig = (config: any) => {
    const {
      DEV_PN_PUB_KEY,
      DEV_PN_SUB_KEY,
      PRD_PN_PUB_KEY,
      PRD_PN_SUB_KEY,
    } = config;

    let publishKey = "";
    let subscribeKey = "";

    if (process.env.REACT_APP_ENVIRONMENT === "local") {
      publishKey = DEV_PN_PUB_KEY;
      subscribeKey = DEV_PN_SUB_KEY;
    } else {
      publishKey = PRD_PN_PUB_KEY;
      subscribeKey = PRD_PN_SUB_KEY;
    }

    if (publishKey && subscribeKey) {
      const mqm = new MQ({
        publishKey,
        subscribeKey,
      });

      dispatch({ type: "setMqm", mqm });
    }
  };

  return null;
};

export default AppConfig;
